/**
 * Pagination helpers shared by the admin console's list screens.
 */

/**
 * The page buttons to render for a numbered pager: always first, last and the pages either side of
 * the current one, with `"ellipsis"` standing in wherever the sequence jumps.
 *
 * Lived as five byte-identical copies inside the audit, tenant, payment, resource and billing-cycle
 * pages; extracted so the pagers cannot drift apart.
 */
export function getPaginationItems(
  currentPage: number,
  totalPages: number,
): (number | "ellipsis")[] {
  const pages = [
    ...new Set([1, currentPage - 1, currentPage, currentPage + 1, totalPages]),
  ]
    .filter((pageNumber) => pageNumber >= 1 && pageNumber <= totalPages)
    .sort((a, b) => a - b);

  return pages.flatMap((pageNumber, index) => {
    const previousPage = pages[index - 1];
    return previousPage && pageNumber - previousPage > 1
      ? ["ellipsis" as const, pageNumber]
      : [pageNumber];
  });
}
